import { render, staticRenderFns } from "./prenotazioneAlpi.vue?vue&type=template&id=2128fbff"
import script from "./prenotazioneAlpi.vue?vue&type=script&lang=js"
export * from "./prenotazioneAlpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports